import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import SiteLayout from "@/components/site/SiteLayout";
import ProtectedRoute from "@/components/site/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import NRICorner from "@/pages/NRICorner";
import Properties from "@/pages/Properties";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Login from "@/pages/Login";
import OwnerDashboard from "@/pages/OwnerDashboard";
import TenantDashboard from "@/pages/TenantDashboard";
import Admin from "@/pages/Admin";

import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/nri-corner" element={<NRICorner />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/login/:role" element={<Login />} />
            <Route path="/owner/dashboard" element={
              <ProtectedRoute role="owner" redirectTo="/login/owner">
                <OwnerDashboard />
              </ProtectedRoute>
            } />
            <Route path="/tenant/dashboard" element={
              <ProtectedRoute role="tenant" redirectTo="/login/tenant">
                <TenantDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute role="admin" redirectTo="/login/owner">
                <Admin />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
